import React from "react";

// TrafficLight Component
const TrafficLight = ({ status, unitHeightPixels = 120 }) => {
    const getLightOpacity = (whichLight, trafficLightStatus) => {
        let lightOpacity = 0.3;
        switch(trafficLightStatus) {
            case 'RECENTLY_STOPPED':
            case 'START':
                if(whichLight === 'RED') {
                    lightOpacity = 1.0;
                }
                break;
            case 'OFFLINE':
                if(whichLight === 'AMBER') {
                    lightOpacity = 1.0;
                }
                break;
            case 'STOP':
                if(whichLight === 'GREEN') {
                    lightOpacity = 1.0;
                }
                break;
        }

        return lightOpacity;
    };

    return (
        <div
            style={{
                width: unitHeightPixels / 3,
                height: unitHeightPixels,
                backgroundColor: "black",
                borderRadius: "10px",
                padding: "5px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            {/* Red light */}
            <div
                style={{
                    width: (unitHeightPixels / 3) * 0.7,
                    height: 0.2333 * unitHeightPixels,
                    borderRadius: "50%",
                    backgroundColor: "red",
                    opacity: getLightOpacity("RED", status)
                }}
            ></div>

            {/* Orange light */}
            <div
                style={{
                    width: (unitHeightPixels / 3) * 0.7,
                    height: 0.2333 * unitHeightPixels,
                    borderRadius: "50%",
                    backgroundColor: "orange",
                    opacity: getLightOpacity("AMBER", status)
                }}
            ></div>

            {/* Green light */}
            <div
                style={{
                    width: (unitHeightPixels / 3) * 0.7,
                    height: 0.2333 * unitHeightPixels,
                    borderRadius: "50%",
                    backgroundColor: "green",
                    opacity: getLightOpacity("GREEN", status)
                }}
            ></div>
        </div>
    );
};

export default TrafficLight;
